import { Component } from 'preact';
import s from './style.css';
import cn from 'classnames';

class Label extends Component {
	shouldComponentUpdate(nextProps) {
		return nextProps.visible !== this.props.visible;
	}

	render() {
		const {
			number,
			total,
			max,
			columns,
			offset = 0,
			visible,
			isSecondary,
			isTight = false,
			totalOffset = 0,
			width = 100,
			height = 100
		} = this.props;

		const maxTotal = total || max;
		const rows = Math.ceil(max / columns);
		const colSize = width / (columns - 1);
		const rowSize = height / (rows + 1);

		const isOffsetRight = offset > max / 2;
		const offsetNum = isOffsetRight ? offset : number + offset;
		const totalOffsetNum = isOffsetRight ? totalOffset : maxTotal + totalOffset;

		// const col = Math.floor(offsetNum / columns) * colSize + colSize / 2;
		// const row = (offsetNum % columns) * rowSize + rowSize / 2;

		const row = offsetNum % columns;
		const col = Math.floor(offsetNum / columns) + (isOffsetRight ? -0.5 : 1.5);

		const percentage = Math.round(number / maxTotal * 100);

		let size = 10;

		if (maxTotal !== number) {
			const totalCol = Math.floor(totalOffsetNum / columns);
			size = Math.abs(totalCol - col) + 2;
		}

		if (maxTotal === max) {
			size = 10;
		}

		if (isTight) {
			size = 4;
		}

		return (
			<div
				className={cn(s.root, {
					[s.offsetRight]: isOffsetRight,
					[s.visible]: visible,
					[s.isSecondary]: isSecondary
				})}
				style={{
					left: `${col * colSize}%`,
					top: `${row * rowSize}%`,
					height: `${rowSize * 3}%`,
					width: `${size * colSize}%`,
					display: percentage > 0 ? 'block' : 'none'
				}}
			>
				<span className={s.text}>{percentage}%</span>
			</div>
		);
	}
}

export default Label;



// WEBPACK FOOTER //
// ./components/RomanceBreakdownViz/Label/index.js